import { Suspense, lazy, useEffect } from "react";
import { Helmet } from "react-helmet"
import ErrorBoundary from "./ErrorBoundary";
import { persistor, store } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import Toast from "./Constant/Toast";
import CustomLazyLoading from "./Components/CustomLazyLoading";
import { HelmetProvider } from 'react-helmet-async'; 

// --- 1. IMPORT THESE TWO FILES ---
import { UploadProvider } from "./Screen/Autherised/Users/UploadContext"; 
import UploadWidget from "./Components/UploadWidget";
// --------------------------------

function App() {
  const AppRouter = lazy(() => import("./Routes"));

  /* Handling Net Status & Visible Title */
  useEffect(() => {
    const handleOnline = () => {
      Toast("s", "Internet connection restored!", "top-center");
    };

    const handleOffline = () => {
      Toast("w", "Internet connection lost!", "top-center");
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
        <title>Our Jewish Story</title>
        <meta name="description" content="An interactive storytelling experience." />
        <meta property="og:title" content="Our Jewish Story" />
        <meta property="og:image" content="https://admindev.ourjewishstory.org/logo.png" />
        </Helmet>
        
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            
            {/* --- 2. WRAP APP WITH UPLOAD PROVIDER HERE --- */}
            {/* This must be INSIDE Redux Provider so context can get the token */}
            <UploadProvider>
            
                <Suspense fallback={<CustomLazyLoading />}>
                  <ErrorBoundary>
                    <AppRouter />
                  </ErrorBoundary>
                </Suspense>

                {/* --- 3. PLACE THE WIDGET HERE --- */}
                {/* It sits outside the router so it floats on all pages */}
                <UploadWidget />

            </UploadProvider>
            {/* --------------------------------------------- */}

          </PersistGate>
        </Provider>
      </HelmetProvider>
    </>
  );
}

export default App;